import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ChevronDown from 'images/icons/controls/chevron-down.svg?react-svg';
import ChevronUp from 'images/icons/controls/chevron-up.svg?react-svg';
import { RadioList, RadioListItem } from 'scy/RadioList';
import { Tabs, Tab } from 'scy/Tabs';
import { uppercase } from 'scy/text/styles.mod.scss';
import { AccentH5, SecondarySmall } from 'scy/text';
import { TextButton } from 'scy/buttons';
import { textLeft, textCenter } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';

export default function DeliveryTimePicker({
  options,
  date,
  slot,
  isASAP,
  labelForASAP,
  selectASAP,
  selectDate,
  selectSlot
}) {
  useEffect(() => {
    if (!date && options.length) {
      selectDate(options[0]);
    }
  }, [date, options, selectDate]);

  function dateIsToday(option) {
    return option && option.date === moment().format('MM/DD/YYYY');
  }

  function canSelectASAP(option) {
    return !!labelForASAP && dateIsToday(option);
  }

  let slots = [];
  if (canSelectASAP(date)) {
    slots.push({ description: labelForASAP, isSlotForASAP: true });
  }
  if (date && date.slots && date.slots.length) {
    slots = slots.concat(date.slots);
  }

  const firstSlots = slots.slice(0, 5);
  const canExpandSlots = slots.length > firstSlots.length;

  const [slotsExpanded, setSlotsExpanded] = useState(false);
  const slotOptions = slotsExpanded ? slots : firstSlots;

  function handleDateChange({ date }) {
    const option = options.find(option => option.date === date);
    selectDate(option);
    if (canSelectASAP(option)) {
      selectASAP();
    } else {
      selectSlot(null);
    }
  }

  function handleSlotChange({ description, isSlotForASAP }) {
    if (isSlotForASAP) {
      selectASAP();
    } else {
      const slot = slots.find(slot => slot.description === description);
      selectSlot(slot);
    }
  }

  return (
    <RadioList className={`${textLeft} ${margin.bottom_sm}`}>
      <Tabs>
        {options.map(option => (
          <Tab
            key={option.date}
            heading={dateIsToday(option) ? 'Today' : option.day}
            subheading={moment(new Date(option.date)).format('MMM D')}
            isSelected={date && date.date === option.date}
            onClick={() => handleDateChange(option)}
          />
        ))}
      </Tabs>

      {slotOptions.map(({ description, isSlotForASAP }) => (
        <RadioListItem
          key={description}
          name="delivery-time"
          id={`delivery-time_${description.replace(/\s/g, '')}`}
          checked={
            isSlotForASAP
              ? !!isASAP
              : !!(slot && slot.description === description)
          }
          onChange={() => handleSlotChange({ description, isSlotForASAP })}
          title={description}
          aside={
            <AccentH5 tag="span" className={uppercase}>
              Free
            </AccentH5>
          }
        />
      ))}

      {canExpandSlots && (
        <SecondarySmall tag="div" className={`${textCenter} ${padding.sm}`}>
          <TextButton
            noUnderline
            type="button"
            onClick={() => setSlotsExpanded(!slotsExpanded)}
          >
            <span className={margin.right_xxs}>
              {slotsExpanded ? 'View Fewer' : 'View All'}
            </span>
            {slotsExpanded ? <ChevronUp /> : <ChevronDown />}
          </TextButton>
        </SecondarySmall>
      )}
    </RadioList>
  );
}
